//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { Mixins } from '@theme/mixins';

interface Props {
  className?: string;
  children?: React.ReactNode;
}

const VerticalDivider = ({ children, className = '' }: Props) => {
  return (
    <DividerWrapper className={className}>
      <Divider />
      {children && (
        <>
          <DividerText>{children}</DividerText>
          <Divider />
        </>
      )}
    </DividerWrapper>
  );
};

const DividerWrapper = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 ${theme.spacings[3]};
`,
);

const Divider = styled.div(
  ({ theme }) => `
  min-width: 1px;
  max-width: 1px;
  height: 100%;
  background-color: ${theme.colors.gray2}
`,
);

const DividerText = styled.div(
  ({ theme }) => `
  ${Mixins.Text.Metatag}
  margin: ${theme.spacings[3]} 0;
`,
);

export default VerticalDivider;
